module.exports = __webpack_public_path__ + "fonts/manrope-regular.12ff9ff6.woff";